<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" id="chapter-5">
<div class="heading heading-with-title heading-without-image" id="chapter-5-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">5</h1>
</div>
</div>
</div>
</div>
<div class="text" id="chapter-5-text">
<p class="first first-in-chapter first-full-width"><span class="drop-cap">B</span>lue-and-white tape crossed the entrance to the village hall and playing fields. A uniformed officer stood guard and waved the marked Vauxhall Astra into the car park. Fleming and Logan climbed out and donned protective clothing and elasticated overshoes.</p>
<p class="subsq">‘Where’s the body?’ Fleming asked the young officer.</p>
<p class="subsq">The officer pointed across the playing field. ‘Far end, just inside the trees. You’ll see the tape marking out the crime scene.’</p>
<p class="subsq">‘The super did reckon there was trouble brewing here, but I’ll bet she didn’t think it would be this,’ Logan said.</p>
<p class="subsq">They reached the inner cordon where another officer logged their names in a notebook. Ducking under the tape, the two detectives headed off into the edge of the woods. SOCOs were already at work searching the area around the body.</p>
<p class="subsq">‘DCI Fleming?’ asked a man appearing from behind a bush.</p>
<p class="subsq">‘Yes, and this is DS Logan,’ Fleming replied, pointing to his colleague.</p>
<p class="subsq">‘Right. I’m DI Oliver. Local CID. Pathologist hasn’t arrived yet. No one’s touched the body.’</p>
<p class="subsq">Fleming nodded. ‘Know who it is?’</p>
<p class="subsq">‘One of the uniforms knew. Local man by the name of Slater… Tom Slater. BMW up by the village hall is his.’</p>
<p class="subsq">‘SOCOs checking it?’</p>
<p class="subsq">‘They will when they’re done here.’</p>
<p class="subsq">‘Was it locked or unlocked?’</p>
<p class="subsq">‘Locked.’</p>
<p class="subsq">‘CCTV up by the village hall?’</p>
<p class="subsq">‘Having it checked.’</p>
<p class="subsq">‘Right, let’s have a look at the body.’</p>
<p class="subsq">Slater was lying on his back, blank eyes staring up at them. There was one bullet hole in the centre of his forehead. A second had penetrated his cheekbone under the right eye. He wore casual clothes: jeans, blue shirt and a light-brown blazer. Fleming knelt down and checked his pockets.</p>
<p class="subsq">There wasn’t much apart from keys and a wallet. A quick look inside the wallet revealed a driving licence confirming the man’s identity. Logan wandered round searching the ground nearby.</p>
<p class="subsq">Fleming handed the contents over to Oliver. ‘Get the SOCOs to bag these.’</p>
<p class="subsq">‘Right.’</p>
<p class="subsq">‘Who found the body?’ Fleming asked.</p>
<p class="subsq">‘Two local boys,’ Oliver said. ‘Shook them up a bit.’</p>
<p class="subsq">‘Get statements though?’</p>
<p class="subsq">‘Down at the station now. Their parents are with them.’</p>
<p class="subsq">‘Send their statements over to me in the major crime unit when they’re done.’</p>
<p class="subsq">‘Sure.’</p>
<p class="subsq">‘What were they doing here?’</p>
<p class="subsq">Oliver shrugged and pursed his lips. ‘It’ll be in their statements.’</p>
<p class="subsq">‘Was Slater married?’</p>
<p class="subsq">‘Yes, a couple of my officers have been round to see his wife.’</p>
<p class="subsq">‘Let me have her address. I’ll need to speak to her.’</p>
<p class="subsq">‘I’ll send it over with the statements.’</p>
<p class="subsq">‘Thanks. I gather things have been getting a bit heated in the village over a proposed development.’</p>
<p class="subsq">Oliver sighed. ‘Yes. Protests, anger, even some death threats.’</p>
<p class="subsq">‘But not taken seriously?’ Fleming guessed.</p>
<p class="subsq">‘No. People do and say things in the heat of the moment. There’s been no physical assaults.’</p>
<p class="subsq">‘Until now,’ Fleming said, looking down at Slater’s body.</p>
<p class="subsq">‘You think it could be to do with the protests?’</p>
<p class="subsq">‘Ever had anything like this happen here before?’</p>
<p class="subsq">‘Not that I know of, no.’</p>
<p class="subsq">‘So I wouldn’t rule it out.’</p>
<p class="subsq">Logan strolled back into sight holding up a golf ball. ‘Don’t suppose it’s worth getting the SOCOs to bag this,’ he said with a smile.</p>
<p class="subsq">Fleming chuckled. ‘I know two boys who might have been looking for that.’</p>
<p class="subsq">‘Nathan’s here,’ Logan said, looking over Fleming’s shoulder.</p>
<p class="subsq">‘Dr Nathan Kumar,’ Fleming explained to Oliver. ‘Home Office registered pathologist.’</p>
<p class="subsq">‘Hello, Alex. Got here before me, I see. Okay to have a look at the body?’</p>
<p class="subsq">‘Sure. Go ahead.’</p>
<p class="subsq">Fleming looked at Logan and pointed up towards the village hall. ‘I’m curious why Slater’s BMW is up there,’ he mused. ‘He’s a local man and it’s not a big village. If he decided to go for a walk, why not go all the way?’</p>
<p class="subsq">‘Could be he preferred soft ground rather than pounding the streets.’</p>
<p class="subsq">‘He’s wearing slip-ons, not walking boots or sturdy shoes.’</p>
<p class="subsq">‘So what are you thinking?’</p>
<p class="subsq">‘He wasn’t going for a walk, and there’s no sign of a struggle. This has all the hallmarks of a professional hit. I reckon the killer arranged to meet Slater by the village hall for some reason. Then forced him over to the trees at gunpoint.’</p>
<p class="subsq">‘Or shot him someplace else and dumped him here.’</p>
<p class="subsq">‘Doesn’t answer the question why Slater parked his BMW where he did. It would also be a bit difficult to manhandle a body all the way across the playing field. And, there are no vehicle tyre tracks.’</p>
<p class="subsq">‘Okay. Let’s assume the killer did arrange to meet Slater at the village hall. That would suggest he knew the killer. Still begs the question why Slater came in his car.’</p>
<p class="subsq">‘Maybe he’d been some other place when he got the call, or the killer told him to come here.’</p>
<p class="subsq">Logan’s face lit up. ‘Makes finding the killer a bit easier if Slater did know him… or her.’</p>
<p class="subsq">‘Depends on how many people he knew, and if they were aware who else he knew.’</p>
<p class="subsq">Logan laughed. ‘Beginning to sound like an extract from <i>Yes Minister.’</i></p>
<p class="subsq">‘Nice to see a sense of humour maintained,’ Kumar said as he approached.</p>
<p class="subsq">‘Logan coming out with one of his wisecracks,’ Fleming said. ‘Initial thoughts, Nathan?’</p>
<p class="subsq">‘Not much apart from the obvious. Shot twice through the head. Close range. The angle of entry and exit points of the bullets suggest the victim was standing facing the killer. Looks like he was holding the gun at roughly the same height as the victim’s head.’</p>
<p class="subsq">‘So a man, or woman, of a similar height?’</p>
<p class="subsq">‘Could be. Death would have been almost instant. If the SOCOs recover the bullets, ballistics should be able to confirm what type of gun the killer used. I’d say a nine-millimetre handgun.’</p>
<p class="subsq">‘Approximate time of death?’</p>
<p class="subsq">‘About twelve to fifteen hours ago. I’ll send you a full report once I get the body back to the mortuary.’</p>
<p class="subsq">‘Okay, thanks.’</p>
<p class="subsq">Fleming waved Oliver over who was talking to one of the SOCOs. ‘Can you put out an appeal for any witnesses to come forward? Get your men to conduct local house-to-house enquiries. Did anyone see or hear anything suspicious. Any sightings of vehicles nearby yesterday… late afternoon, evening.’</p>
<p class="subsq">‘On it.’</p>
<p class="subsq">Fleming turned to Logan. ‘We need contact details for Slater’s family, friends and colleagues. Slater’s phone would be a starting point. Forensics and pathology reports will help inform further lines of enquiry.’</p>
<p class="subsq">‘So this is the quiet village the chief constable wants to move to,’ Logan muttered as they made their way back to their car.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter-005.vue?94996af4